import {
  Modal,
  Box,
  Typography,
  Button,
  Stack,
  Divider,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const buttonSx = {
  textTransform: "none",
  fontWeight: 600,
  borderRadius: "10px",
  py: 1,
};

const ModalComponent = ({
  title,
  subtitle,
  open,
  handleOpen,
  handleSubmit,
  alternateSaveMessage,
  submitColor = "primary",
  children,
  theme,
  maxWidth = 520,
}) => {
  const onSubmit = (e) => {
    e.preventDefault();
    if (handleSubmit) handleSubmit(e);
  };

  const hasSubmit = typeof handleSubmit === "function";

  return (
    <Modal
      open={open}
      onClose={handleOpen}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "#fff",
          boxShadow: "1px 5px 5px 1px rgba(0,0,0,0.18)",
          borderRadius: "15px",
          width: { xs: "calc(100% - 32px)", sm: maxWidth },
          maxWidth: "100%",
          maxHeight: "90vh",
          overflow: "auto",
          outline: "none",
        }}
      >
        <Stack
          direction="row"
          alignItems="flex-start"
          justifyContent="space-between"
          spacing={1}
          sx={{ px: { xs: 2.5, sm: 3 }, pt: { xs: 2.5, sm: 3 }, pb: 1.5 }}
        >
          <Box sx={{ minWidth: 0, pr: 1 }}>
            <Typography
              id="modal-title"
              variant="h6"
              component="h2"
              sx={{ fontWeight: 600, color: "black", lineHeight: 1.3 }}
            >
              {title}
            </Typography>
            {subtitle ? (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                {subtitle}
              </Typography>
            ) : null}
          </Box>
          <IconButton
            aria-label="Close"
            onClick={handleOpen}
            size="small"
            sx={{
              color: "text.secondary",
              borderRadius: "8px",
              mt: -0.5,
              mr: -0.5,
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Stack>

        <Divider />

        <Box
          id="modal-description"
          sx={{ px: { xs: 2.5, sm: 3 }, py: 2.5 }}
        >
          {children || null}
        </Box>

        <Divider />

        <Stack
          direction={{ xs: "column-reverse", sm: "row" }}
          spacing={1.25}
          justifyContent="flex-end"
          sx={{ px: { xs: 2.5, sm: 3 }, py: 2 }}
        >
          <Button
            variant="outlined"
            color="inherit"
            onClick={handleOpen}
            theme={theme}
            sx={{
              ...buttonSx,
              borderColor: "divider",
              minWidth: { sm: 110 },
            }}
          >
            Cancel
          </Button>

          {hasSubmit ? (
            <Button
              type="button"
              variant="contained"
              color={submitColor}
              onClick={onSubmit}
              theme={theme}
              sx={{
                ...buttonSx,
                minWidth: { sm: 120 },
              }}
            >
              {alternateSaveMessage || "Submit"}
            </Button>
          ) : null}
        </Stack>
      </Box>
    </Modal>
  );
};

export default ModalComponent;
